// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[data-v-2e148409]:read-only {
  cursor: pointer;
  background-color: white;
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/js/vue/apps/Contact.vue","webpack://./Contact.vue"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,uBAAA;EACA,YAAA;ACAF","sourcesContent":["\r\ninput:read-only {\r\n  cursor: pointer;\r\n  background-color: white;\r\n  color: black;\r\n}\r\n","input:read-only {\n  cursor: pointer;\n  background-color: white;\n  color: black;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
